import { type Jast, type OrderByField, ORDER_BY_DIRECTION_DESC } from '@atlaskit/jql-ast';
import { substring } from './common.tsx';
import { sanitizeClauseName } from './sanitize-clause-name.tsx';

export const setPrimarySortField = (
	jast: Jast,
	sortField: string,
	sortDirection: string = ORDER_BY_DIRECTION_DESC,
	aliases: string[],
): string => {
	const orderBy = jast.query?.orderBy;
	const jql = jast.represents;

	if (!orderBy || !orderBy.fields.length) {
		return `${jql} ORDER BY ${sortField}${sortDirection ? ` ${sortDirection}` : ''}`;
	}

	const includedFields = new Set([sortField, ...aliases]);
	const sanitizedSortField = sanitizeClauseName(sortField);

	const orderByFields: OrderByField[] = orderBy.fields;
	const fieldsJql = orderByFields
		// filter duplicates
		.filter((field) => {
			const { position } = field.field;
			const fieldValue =
				field.field.properties && position
					? substring(jql, position[0], position[1])
					: field.field.value;
			if (includedFields.has(fieldValue)) {
				return false;
			}
			includedFields.add(fieldValue);
			return true;
		})
		// convert fields to jql
		.reduce(
			(acc, field) => {
				const { position } = field;
				// acc.push(`${field.field.value} ${field.direction?.value || ''}`);
				if (position) {
					acc.push(substring(jql, position[0], position[1]));
				}
				return acc;
			},
			[`${sanitizedSortField} ${sortDirection}`],
		)
		.join(', ');

	const startPosition = orderBy.fields[0].position;
	if (startPosition) {
		const start = startPosition[0];
		return `${substring(jql, 0, start)}${fieldsJql}`;
	}
	return jql;
};
